import { ref } from 'vue';
import { useQuasar } from 'quasar';

export function useCouponActions() {
  const $q = useQuasar();
  const copying = ref(false);
  const visiting = ref(false);

  function copyCode(code) {
    copying.value = true;
    navigator.clipboard.writeText(code).then(() => {
      $q.notify({ 
        message: 'Code copied to clipboard!', 
        color: 'positive', 
        icon: 'content_copy', 
        position: 'top', 
        timeout: 2000 
      });
    }).catch(() => {
      $q.notify({ 
        message: 'Failed to copy code', 
        color: 'negative', 
        position: 'top', 
        timeout: 2000 
      });
    }).finally(() => {
      copying.value = false;
    });
  }

  function visitStore(coupon) {
    if (coupon.store && coupon.store.website_url) {
      visiting.value = true;
      window.open(coupon.store.website_url, '_blank');
      setTimeout(() => {
        visiting.value = false;
      }, 1000); // Reset after a short delay
    } else {
      $q.notify({ 
        message: 'Store website not available', 
        color: 'warning', 
        position: 'top', 
        timeout: 2000 
      });
    }
  }

  return {
    copying,
    visiting,
    copyCode,
    visitStore
  };
}

export function useImageHandling() {
  function handleImageError(evt) {
    evt.target.src = '/images/placeholder.png';
    evt.target.onerror = null;
    evt.target.classList.add('fallback-image');
  }

  return {
    handleImageError
  };
}
